
import styled from 'styled-components'
import velocidad from '../imgs/velocidad.jpg'
import Arrow from '../imgs/Arrow.png'


const Container=styled.div`
	width:100vw;
	height:95vh;
	display:flex;
	justify-content: space-evenly;
	align-items:center;
	background-image:url(${velocidad});
	background-color:black;
	background-repeat:no-repeat;
	background-size:contain;
	position:relative;
	background-position: left;
	
 `;

const ContainerIframe=styled.div`
	background-color:white;
	right:10vw;
	width:300px;
	height:65vh;
	display:flex;
	border-radius:20px;
	overflow:hidden

 `;

 const ContainerTexto=styled.div`
 	display:flex;
 	flex-direction:column;
 	align-items:center;

  `;

 const Texto=styled.div`
 	font-family: "Orbitron", sans-serif;
  font-optical-sizing: auto;
  font-weight: <weight>;
  font-style: normal;

	font-size:49px;
 	color:#FE6A07;
 	width:40vw;
 	text-align:end;
 	@media (max-width: 550px) {
    display:none;    
  }
  `;

  const ArrowOrange=styled.img`
  	height:25vh;
  	@media (max-width: 550px) {
    display:none;    
  }

   `;


export default function Velocidad(){
	
	return(<Container>
			<ContainerTexto>
				<Texto><b>Verifica tu velocidad de internet</b></Texto>
				<ArrowOrange src={`${Arrow}`}/>

			</ContainerTexto>
			<ContainerIframe >				
				<iframe  src="https://fast.com/es/" width="100%" height="100%" title="fast"></iframe>
			</ContainerIframe>	
		</Container>

		)
}